<template>
  <div>
    <div class="main-container">
      <div class="d-flex flex-column flex-md-row">
        <trade-detail-form
          v-if="trade_detail_form.flag"
          :trade_detail_form="trade_detail_form"
        />
        <reviewand-post-trade
          @trade-edit="tradeEdit"
          @share-trade="shareTrade"
          @reloadTrades="reloadTrades"
          :trade_review_data="trade_review_data"
          v-if="trade_review_data.flag"
        />
        <TradeForm @reloadTrades="reloadTrades" />

        <v-main
          class="fill-height px-5 px-md-8 py-6 scrollable child-1"
          style="position: relative"
        >
          <router-view></router-view>
        </v-main>
        <!-- {{ $route.name != "newsPage" }}
        {{ !$vuetify.breakpoint.smAndDown }} -->
        <!-- {{ ($route.name = "newsPage" && !$vuetify.breakpoint.xsOnly) }} -->
        <!-- $route.name != 'WebinarsPage' && -->

        <div
          v-if="!hideRecommended || !$vuetify.breakpoint.smAndDown"
          class="child-2 py-6 px-6 scrollable"
        >
          <p>Recommendations</p>
          <div v-if="profilesLoading" class="">
            <v-skeleton-loader
              v-for="item in 5"
              :key="item.id"
              class="pa-2"
              type="list-item-avatar-three-line"
            ></v-skeleton-loader>
          </div>
          <div v-if="!profilesLoading.length">
            <profile-card-component
              :profile_object="item"
              v-for="item in influencers_list"
              :key="item.id"
              @reload-home-profile="getInfluencersList"
              class="mt-4"
            />
            <div
              class="text-center"
              v-if="
                !influencerHide &&
                influencerNumPages > 1 &&
                influencerPage !== influencerNumPages
              "
              v-intersect="onInfluencerIntersect"
            >
              <v-progress-circular
                indeterminate
                color="#2f80ed"
              ></v-progress-circular>
              Loading More...
            </div>
          </div>
        </div>
      </div>
      <v-fab-transition class="floatingIcon">
        <v-btn
          color="#2D8CFF"
          dark
          class="d-sm-none mb-4 mb-15 text-capitalize elevation-4"
          fixed
          rounded
          bottom
          inner-height="44"
          right
          style="z-index: 4"
          @click="addTrade()"
        >
          <v-icon small>mdi-plus</v-icon>
          <span style="font-weight: 800; letter-spacing: 0px">Add Trade</span>
        </v-btn>
      </v-fab-transition>
    </div>
    <upload-video></upload-video>
    <video-detail></video-detail>
    <bonusCreditsModalVue></bonusCreditsModalVue>
  </div>
</template>

<script>
import Axios from "@/api/BaseAxios.js";
import ProfileCardComponent from "@/components/Profile/ProfileCardComponent.vue";
import { isAuthenticated } from "../common/commonFunctions";
import TradeDetailForm from "@/components/Trade/TradeDetailForm.vue";
import TradeForm from "@/components/Trade/TradeForm.vue";
import ReviewandPostTrade from "@/components/Trade/ReviewandPostTrade.vue";

// import ProfitableTradeList from "@/components/Trending/ProfitableTrade/ProfitableTradeList.vue";
// import PerformingTraderList from "@/components/Trending/PerformingTrader/PerformingTraderList.vue";
// import UpcomingTradeList from "@/components/Trending/UpcomingTrade/UpcomingTradeList.vue";
import { mapActions } from "vuex";
// import VideoCard from "../components/VideoCourse/VideoCard/VideoCard.vue";
import commonFunctions from "@/common/commonFunctions";
import emitterKey from "@/helper/emitterKey";
import bonusCreditsModalVue from "@/components/gamification/bonusCreditsModal.vue";
export default {
  name: "TrendingPage",
  components: {
    "profile-card-component": ProfileCardComponent,
    bonusCreditsModalVue,
    TradeForm,
    TradeDetailForm,
    ReviewandPostTrade,
    // ProfitableTradeList,
    // PerformingTraderList,
    // UpcomingTradeList,
    // GroupHorizontalList: () => import("@/components/GroupHorizontalList"),
    UploadVideo: () =>
      import(
        "@/components/VideoCourse/AddVideoData/UploadVideo/UploadVideo.vue"
      ),
    VideoDetail: () =>
      import(
        "@/components/VideoCourse/AddVideoData/VideoDetail/VideoModal.vue"
      ),
    // VideoCard,
  },
  metaInfo: {
    title: "Trending",
  },
  data: () => ({
    tradesLoading: false,
    user_id: commonFunctions.getUserId(),
    profilesLoading: false,
    influencers_list: [],
    statusItems: [
      { name: "Live", value: "Active" },
      { name: "Upcoming", value: "Inactive" },
    ],
    buysellItems: ["Buy", "Sell"],
    sortItems: ["By Security (A To Z)"],
    durationItems: [
      { name: "Intra-day", value: "Intra-day-BTST (1~2 days)" },
      { name: "Short-term", value: "Short term (1~2 weeks)" },
      { name: "Intermediate", value: "Intermediate (2~6 weeks)" },
      { name: "Long-term", value: "Long term (>6 weeks)" },
    ],
    duration: null,
    status: null,
    buy_sell: null,
    sorts: [],
    trending_videos: [],
    loadingTrendingVideos: false,
    page: 1,
    numPages: 1,
    influencerPage: 1,
    influencerNumPages: 1,
    trades: [],
    hide: true,
    influencerHide: false,
    is_Intersecting: false,
    home_page_no_data_illustation: require("../assets/images/home_page_no_data_illustation.png"),
    trade_form_data: {
      flag: false,
      id: null,
      trade_data: {},
      trade_edit: false,
    },
    trade_detail_form: {
      flag: false,
      id: null,
    },
    trade_review_data: {
      flag: false,
      trade_data: {},
    },
    premium_groups: [],
  }),

  computed: {
    hideRecommended() {
      if (
        this.$route.name != "marketPage" ||
        this.$route.name != "newsPage" ||
        this.$route.name != "EconomicCalendarPage"
      ) {
        return true;
      }
      return false;
    },
  },
  methods: {
    ...mapActions({
      toggleTradeModal: "tradeData/toggleModal",
      toggleAddTradeModal: "addTrade/toggleTradeModal",
    }),
    getTradesList(item) {
      const successHandler = (res) => {
        if (item == "append") {
          res.data.result.forEach((item) => {
            this.trades.push(item);
          });
          this.numPages = res.data.num;
          this.tradesLoading = false;
        } else {
          this.trades = res.data.result;
          this.tradesLoading = false;
          this.numPages = res.data.num;
        }
      };
      const user_id = localStorage.getItem("user_id");
      const errorHandler = (err) => {
        console.log(err);
      };
      Axios.request_GET(
        `api/trade/all-trade-list/${user_id}/${this.page}/${
          this.status == "" ? null : this.status
        }/${this.buy_sell == "" ? null : this.buy_sell}/${
          this.duration == "" ? null : this.duration
        }`,
        {},
        {},
        successHandler,
        errorHandler,
        false,
        false
      );
    },
    filterTrades() {
      this.page = 1;
      this.getTradesList();
    },
    reloadTrades() {
      this.page = 1;
      this.getTradesList();
    },
    getInfluencersList(item) {
      const successHandler = (res) => {
        console.log(res);
        if (item == "append") {
          res.data.result.forEach((i) => {
            this.influencers_list.push(i);
          });
          this.influencerNumPages = res.data.num;
        } else {
          this.influencers_list = res.data.result;
          this.influencerNumPages = res.data.num;
        }
        this.profilesLoading = false;
      };
      const errorHandler = () => {};
      const user_id = localStorage.getItem("user_id");
      Axios.request_GET(
        `api/influencers-list/${user_id}/${this.influencerPage}`,
        {},
        {},
        successHandler,
        errorHandler,
        false,
        false
      );
    },
    onIntersect(entries) {
      this.hide = true;
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.page += 1;
          if (this.page <= this.numPages) {
            this.getTradesList("append");
          } else {
            this.hide = false;
          }
        }
      });
    },
    onInfluencerIntersect(entries) {
      this.influencerHide = false;
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.influencerPage += 1;
          if (this.influencerPage <= this.influencerNumPages) {
            this.getInfluencersList("append");
          } else {
            this.influencerHide = true;
          }
        }
      });
    },
    addTrade() {
      this.$logEvent("add_trade_trending_page");
      // console.log("trending event fire");

      if (this.$vuetify.breakpoint.xsOnly) {
        this.$logEvent("mweb_add_trade_trending_page");
      }
      this.trade_form_data.flag = true;
      // this.toggleTradeModal({ show: true, type: "add" });
      this.toggleAddTradeModal({ show: true, type: "add" });
    },
    reviewTrade(data) {
      this.trade_review_data.trade_data = data;
      this.trade_review_data.flag = true;
    },
    tradeEdit(data) {
      this.trade_form_data.trade_data = data;
      this.trade_form_data.trade_edit = true;
      this.trade_form_data.flag = true;
    },
    shareTrade(data) {
      navigator.share(
        {
          title: "Covesto",
          text: `Hello, ${data.posted_by_name} has shared a trade recommendation on Covesto.${data.trade_type} ${data.security_name}
            To know more details and get live updates, follow the trade at `,
          url: `https://covesto.in/trade/${data.id}/${data.security.name}`,
        },
        {
          skype: false,
          pinterest: false,
          print: false,
          sms: false,
        }
      );
      this.getTradeList(0);
    },
    getPremiumGroups() {
      const successHandler = (res) => {
        this.premium_groups = res.data.premium_groups;
      };
      const failureHandler = () => {};
      let formData = {};
      formData["detail_count"] = 5;
      Axios.request_GET(
        "/api/premium-groups",
        formData,
        {},
        successHandler,
        failureHandler,
        false,
        true
      );
    },
    getTrendingVideos() {
      this.loadingTrendingVideos = true;
      const successHandler = (res) => {
        this.trending_videos = res.data.trending_videos;
        this.loadingTrendingVideos = false;
      };
      const failureHandler = () => {
        this.loadingTrendingVideos = false;
      };
      let formData = {};
      formData["detail_count"] = 5;
      formData["page_number"] = 1;
      Axios.request_GET(
        "/video/trending-videos/",
        formData,
        {},
        successHandler,
        failureHandler,
        false,
        true
      );
    },
  },
  mounted() {
    const bonusCreditModal = localStorage.getItem("bonusCreditModal");

    if (bonusCreditModal === "true") {
      // Update the Vuex store value
      this.$store.commit("gamification/SET_BONUS_CREDIT_MODAL", true);
      localStorage.removeItem("bonusCreditModal");
    }
    this.tradesLoading = true;
    this.getTradesList();
    this.getTrendingVideos();
    this.$store.dispatch("Auth/getNotifications");
    this.profilesLoading = true;
    this.getInfluencersList();
    this.getPremiumGroups();
    if (isAuthenticated()) {
      this.$store.state.Auth.isPrivate = true;
      this.$store.state.Auth.checkStatus = "HOME";
    } else {
      this.$store.state.Auth.checkStatus = "LOGIN";
      this.$router.push({ name: "AuthPage" });
    }
    // this.$logEvent("home_view");
  },
  created() {
    const self = this;

    this.eventBus.$on(emitterKey.UPDATE_VIDEO_PLAYLIST, () => {
      // console.log(emitterKey.UPDATE_VIDEO_PLAYLIST);
      self.getTrendingVideos();
    });
  },
  destroyed() {
    this.eventBus.$off(emitterKey.UPDATE_VIDEO_PLAYLIST);
  },
};
</script>

<style lang="scss" scoped>
@import "~vuetify/src/styles/styles.sass";

@media #{map-get($display-breakpoints, 'md-and-up')} {
  .scrollable {
    max-height: 100vh;
    overflow-y: auto;
  }

  .child-1 {
    max-width: 65%;
  }
}

.main-container {
  min-height: calc(100vh - 64px);
  overflow-y: hidden;
  background-color: #f6f7fa;
}

.sort-select {
  border: 1px solid rgba(51, 51, 51, 0.16) !important;
  width: 10px;
  height: 30px;
}
p {
  font-weight: 800;
  font-size: 18px;
}
.child-2 {
  background-color: #f6f7fa !important;
  border-left: 1px solid #d9d7d7;
  max-width: 450px;
  flex-grow: 1;
}
.selectBox {
  margin-right: 5px;
  width: 100%;
  height: 55px !important;
}
.add-trade-button {
  text-transform: capitalize;
  letter-spacing: 0px;
  color: white;
}
.floatingIcon {
  display: none;
}

@media all and (max-width: 600px) {
  .add-trade-button {
    display: none;
  }
  .floatingIcon {
    display: inline-flex !important;
  }
  .sort-and-filter {
    text-align: center !important;
  }
}
@media only screen and (max-width: 600px) {
  .add-trade-button {
    display: none;
  }
  .floatingIcon {
    display: inline-flex !important;
  }
  .sort-and-filter {
    text-align: center !important;
  }
}
</style>
